import { useAdminUserLookup } from '../api/admin.api'

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function useResolvedAdminUser(query: string) {
  const normalized = query.trim()
  const lookup = useAdminUserLookup(normalized)
  const resolvedUser = lookup.data?.user ?? null
  const isEmailQuery = normalized.includes('@')
  const isUserIdQuery = UUID_PATTERN.test(normalized)
  const resolvedUserId = resolvedUser?.id ?? (isUserIdQuery ? normalized : '')

  return {
    query: normalized,
    isEmailQuery,
    isUserIdQuery,
    lookup,
    resolvedUser,
    resolvedUserId,
    notFound:
      normalized.length > 0 &&
      (isEmailQuery || isUserIdQuery) &&
      lookup.isFetched &&
      !lookup.isError &&
      resolvedUser === null,
  }
}
